import { Dialog, RadioGroup, Switch, Transition } from "@headlessui/react";
import { Icon } from "@iconify/react";
import { Fragment, useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  FitAThonRegister,
  getCouponDetails,
  getEmailExists,
} from "../../api/api";
import ic_close from "../../assets/icons/ic_close.svg";
import { useAuthContext } from "../../context/AuthContext";
import { validPhone } from "../../utils/Utils";
import CustomDialog from "../basic/Dialog";
import IconButton from "../basic/IconButton";
import { CuratingPlaylist, OtpVerification } from "./CreateAccountDialog";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import healthyLife from "../../assets/images/healthy_life.png";

export function RegistrationStep1({
  isRegister,
  name,
  setName,
  email,
  setEmail,
  password,
  mobile,
  setMobile,
  setPassword,
  gender,
  setGender,
  height,
  setHeight,
  weight,
  setWeight,
  heightUnit,
  setHeightUnit,
  weightUnit,
  setWeightUnit,
  dob,
  setDob,
  register,
  coupon,
  setCoupon,
  registerThrough,
  wasBackPressed,
  onClickNext,
  companyName,
  setCompanyName,
}) {
  const [showOtp, setShowOtp] = useState(false);
  const [showCouponApplied, setShowCouponApplied] = useState(false);
  const [passwordInputType, setPasswordInputType] = useState("password");
  const [feet, setFeet] = useState(Math.floor(height / 2.54 / 12));
  const [inch, setInch] = useState(
    (height / 2.54 - 12 * Math.floor(height / 2.54 / 12)).toFixed(2)
  );
  const [extraTrailDays, setExtraTrailDays] = useState(0);

  // Auto-Fill by Session-Storage
  const autoFirstName = sessionStorage.getItem("first_name");
  const autoLastName = sessionStorage.getItem("last_name");
  const autoMobile = sessionStorage.getItem("mobile");
  const autoDob = sessionStorage.getItem("done");
  if (autoFirstName && autoLastName && autoMobile && autoDob != null) {
    setName(autoFirstName + " " + autoLastName);
    setMobile(autoMobile);
    setDob(autoDob);
  }

  return (
    <>
      <CustomDialog
        show={showOtp}
        close={() => {
          setShowOtp(false);
        }}
      >
        <Dialog.Panel
          className={`w-full max-w-xl transform overflow-hidden rounded-2xl bg-[#0B0F19] p-6 text-left align-middle shadow-xl transition-all`}
        >
          <div className="w-full flex justify-end items-end">
            <IconButton
              icon={ic_close}
              className="shadow-xl flex justify-end"
              onClick={() => setShowOtp(false)}
            />
          </div>
          <OtpVerification
            // email={registerThrough == "email" ? email : null}
            mobile={mobile}
            onVerified={() => {
              setShowOtp(false);
              onClickNext();
            }}
          />
        </Dialog.Panel>
      </CustomDialog>

      <Transition appear show={true}>
        <Transition.Child
          as={Fragment}
          enter="transform transition ease-in-out duration-300"
          enterFrom={wasBackPressed ? "-translate-x-full" : "translate-x-full"}
          enterTo={wasBackPressed ? "translate-x-0" : "translate-x-0"}
          leave="transform transition ease-in-out duration-300"
          leaveFrom={wasBackPressed ? "translate-x-0" : "translate-x-0"}
          leaveTo={wasBackPressed ? "-translate-x-full" : "translate-x-full"}
        >
          <div
            className={`w-full transform py-6 text-left align-middle transition-all space-y-5`}
          >
            <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
              <p className="font-medium basis-2/12 text-white text-lg">
                Company Name*{" "}
              </p>
              <input
                className="px-4 py-3 md:w-80 rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700 "
                placeholder="Company Name"
                value={companyName}
                onChange={(e) => {
                  if (e.target.value == "") {
                    setCompanyName("");
                  } else if (e.target.value.match(/^[A-Za-z0-9]+$/)) {
                    setCompanyName(e.target.value);
                  }
                }}
              />
            </div>
            {isRegister && (
              <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
                <p className="font-medium basis-2/12 text-white text-lg">
                  Name*
                </p>
                <input
                  className="px-4 py-3 md:w-80 rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700 "
                  placeholder="Name"
                  id="full-name"
                  value={name}
                  onChange={(e) => {
                    if (e.target.value == "") {
                      setName("");
                    } else if (e.target.value.match(/^[A-Za-z]+$/)) {
                      setName(
                        e.target.value
                          .replace(/[^\w\s\][^,\[\]\^]/gi, "")
                          .replace(/[0-9]/g, "")
                      );
                    }
                  }}
                />
              </div>
            )}

            {isRegister && (
              <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
                <p className="font-medium basis-2/12 text-white text-lg">
                  Mobile
                  {registerThrough == "mobile" ? "*" : "*"}
                </p>
                <input
                  className="px-4 py-3 md:w-80 rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700 "
                  placeholder="Mobile"
                  id="mobile-number"
                  value={mobile}
                  onChange={(e) => {
                    setMobile(e.target.value);
                  }}
                  type="number"
                  pattern="[0-9]+"
                />
              </div>
            )}
            <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
              <p className="font-medium basis-2/12 text-white text-lg">
                Birthday*
              </p>
              <div className=" md:w-80">
                <DatePicker
                  selected={dob}
                  onChange={(date) => setDob(date)}
                  dateFormat="dd/MM/yyyy"
                  allowSameDay={false}
                  endDate={new Date()}
                  maxDate={new Date()}
                  placeholderText="Date of Birth"
                  closeOnScroll={false}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  className="flex flex-1 px-4 w-full py-3 rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700"
                  id="dob"
                />
              </div>
            </div>
            <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
              <p className="font-medium basis-2/12 text-white text-lg">Sex*</p>
              <RadioGroup
                value={gender}
                onChange={setGender}
                className="grid grid-cols-2 w-full md:w-80 gap-4"
              >
                <RadioGroup.Option value="male">
                  {({ checked }) => (
                    <p
                      className={`${
                        checked
                          ? `bg-new-lightGray text-black `
                          : ` border-[1px] border-customGray-700 text-primary-white`
                      } text-lg font-medium rounded-full text-center px-8 py-2 cursor-pointer`}
                    >
                      Male
                    </p>
                  )}
                </RadioGroup.Option>
                <RadioGroup.Option value="female">
                  {({ checked }) => (
                    <p
                      className={`${
                        checked
                          ? `bg-new-lightGray text-black `
                          : ` border-[1px] border-customGray-700 text-primary-white`
                      } text-lg font-medium rounded-full text-center px-8 py-2 cursor-pointer`}
                    >
                      Female
                    </p>
                  )}
                </RadioGroup.Option>
              </RadioGroup>
            </div>
            <p className="font-medium  text-xs text-primary-gray capitalize">
              we are inclusive of all genders, however we need your biological
              sex for scientific purposes
            </p>
            <div className="flex flex-col md:flex-row mt-4 md:items-center md:space-x-5">
              <p className="font-medium basis-2/12 text-white text-lg">
                Height*
              </p>
              <div className="flex flex-row items-center md:space-x-2">
                {heightUnit == "cm" && (
                  <input
                    className="px-4 py-3 w-24 rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700 "
                    placeholder={heightUnit}
                    value={height}
                    onChange={(e) => {
                      setHeight(e.target.value);
                    }}
                    type="number"
                  />
                )}
                <div className="flex flex-col md:flex-row w-full gap-5">
                  {heightUnit == "ft" && (
                    <input
                      className="px-4 py-3 w-24 rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700 "
                      placeholder={"Ft."}
                      value={feet}
                      onChange={(e) => {
                        setFeet(e.target.value);

                        setHeight(
                          (30.48 * e.target.value + inch * 2.54).toFixed(2)
                        );
                      }}
                      type="number"
                    />
                  )}
                  {heightUnit == "ft" && (
                    <input
                      className="px-4 py-3 w-24 rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700 "
                      placeholder={"Inc."}
                      value={inch}
                      onChange={(e) => {
                        setInch(e.target.value);
                        setHeight(
                          (feet * 30.54 + e.target.value * 2.54).toFixed(2)
                        );
                      }}
                      type="number"
                    />
                  )}
                </div>
                <div className="flex flex-row items-center gap-5 mt-5 md:mt-0">
                  <p
                    className={`${
                      heightUnit == "cm"
                        ? "text-primary-orange"
                        : "text-primary-gray"
                    } font-medium`}
                  >
                    CENT.
                  </p>
                  <Switch
                    checked={heightUnit == "ft"}
                    onChange={(checked) => {
                      if (checked) {
                        setHeightUnit("ft");
                      } else {
                        setHeightUnit("cm");
                      }

                      if (checked) {
                        setFeet(Math.floor(height / 2.54 / 12));
                        setInch(
                          (
                            height / 2.54 -
                            12 * Math.floor(height / 2.54 / 12)
                          ).toFixed(2)
                        );
                      }
                    }}
                    className={`bg-primary-orange
          relative items-center inline-flex h-[20px] w-[35px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
                  >
                    <span
                      aria-hidden="true"
                      className={`${
                        heightUnit == "ft" ? "translate-x-4" : "-translate-x-2"
                      }
            pointer-events-none justify-center items-center  inline-flex h-[24px] w-[24px] transform rounded-full bg-primary-white drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] ring-0 transition duration-200 ease-in-out`}
                    >
                      <span
                        aria-hidden="true"
                        className={`${
                          heightUnit == "ft"
                            ? "translate-x-0"
                            : "-translate-x-0"
                        }
            pointer-events-none inline-block drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] h-[12px] w-[12px] transform rounded-full bg-white  ring-0 transition duration-200 ease-in-out`}
                      />
                    </span>
                  </Switch>

                  <p
                    className={`${
                      heightUnit == "ft"
                        ? "text-primary-orange"
                        : "text-primary-gray"
                    } font-medium`}
                  >
                    FT.
                  </p>
                </div>
              </div>
            </div>
            <div className="flex flex-col md:flex-row mt-4 md:items-center md:space-x-5">
              <p className="font-medium basis-2/12 text-white text-lg">
                Weight*
              </p>
              <div className="flex flex-row items-center md:space-x-4">
                <input
                  className="px-4 py-3 w-24 rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700 "
                  placeholder={weightUnit}
                  value={weight}
                  onChange={(e) => {
                    setWeight(e.target.value);
                  }}
                  type="number"
                />
                <div className="flex flex-col md:flex-row w-full gap-5"></div>
                <div
                  // className="flex flex-row items-center gap-5 mt-5 md:mt-0"
                  className="flex flex-row items-center gap-5 mt-5 md:mt-0"
                >
                  <p
                    className={`${
                      weightUnit == "KG"
                        ? "text-primary-orange"
                        : "text-primary-gray"
                    } font-medium`}
                  >
                    KG.
                  </p>
                  <Switch
                    checked={weightUnit == "lbs"}
                    onChange={(checked) => {
                      if (checked) {
                        setWeightUnit("lbs");
                      } else {
                        setWeightUnit("KG");
                      }
                      if (checked) {
                        setWeight((weight / 0.453592).toFixed(2));
                      } else {
                        setWeight((weight * 0.453592).toFixed(2));
                      }
                    }}
                    className={`bg-primary-orange
          relative items-center inline-flex h-[20px] w-[35px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
                  >
                    <span
                      aria-hidden="true"
                      className={`${
                        weightUnit == "lbs" ? "translate-x-4" : "-translate-x-2"
                      }
            pointer-events-none justify-center items-center  inline-flex h-[24px] w-[24px] transform rounded-full bg-primary-white drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] ring-0 transition duration-200 ease-in-out`}
                    >
                      <span
                        aria-hidden="true"
                        className={`${
                          weightUnit == "lbs"
                            ? "translate-x-0"
                            : "-translate-x-0"
                        }
            pointer-events-none inline-block drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] h-[12px] w-[12px] transform rounded-full bg-white  ring-0 transition duration-200 ease-in-out`}
                      />
                    </span>
                  </Switch>
                  <p
                    className={`${
                      weightUnit == "lbs"
                        ? "text-primary-orange"
                        : "text-primary-gray"
                    } font-medium`}
                  >
                    LBS.
                  </p>
                </div>
              </div>
            </div>
            <div className="flex justify-end">
              <div
                className="max-w-max mt-5 text-white cursor-pointer text-sm rounded bg-primary-purple px-5 py-4"
                onClick={async () => {
                  if (!companyName && isRegister) {
                    toast("Company Name is required", { type: "error" });
                  } else if (!name && isRegister) {
                    toast("Name is required", { type: "error" });
                  } else if (
                    !validPhone(mobile) &&
                    isRegister &&
                    registerThrough == "mobile"
                  ) {
                    toast("Invalid mobile", { type: "error" });
                  } else if (!validPhone(mobile) && isRegister && mobile) {
                    toast("Invalid mobile", { type: "error" });
                  } else if (dob == null) {
                    toast("Date of Birth is required", { type: "error" });
                  } else if (!gender) {
                    toast("Gender is required", { type: "error" });
                  } else if (!height || height < 0) {
                    toast("Height is required", { type: "error" });
                  } else if (
                    heightUnit != "cm" &&
                    (feet < 2 || feet > 7 || inch < 5 || inch > 5)
                  ) {
                    toast("Height must be between 3.5 ft.to 7.5 ft.", {
                      type: "error",
                    });
                  } else if (
                    heightUnit != "ft" &&
                    (height < 106 || height > 228)
                  ) {
                    toast("Height must be between 106 cm to 228 cm.", {
                      type: "error",
                    });
                  } else if (!weight) {
                    toast("Weight is required", { type: "error" });
                  }
                  // else if (weight <= 1) {
                  //   toast("Weight must be between 20 kg to 150", { type: "error" });
                  // }
                  else if (
                    weightUnit == "lbs" &&
                    (weight < 66 || weight > 385)
                  ) {
                    toast("Weight must be between 66 and 385 lbs.", {
                      type: "error",
                    });
                  } else if (
                    weightUnit != "lbs" &&
                    (weight < 30 || weight > 175)
                  ) {
                    toast("Weight must be between 30 and 175 kgs.", {
                      type: "error",
                    });
                  } else {
                    if (!isRegister) {
                      onClickNext();
                      return;
                    }

                    if (coupon.length > 0) {
                      const response = await getCouponDetails(coupon);
                      if (!response?.success) {
                        toast(response.message, { type: "error" });
                        return;
                      } else {
                        setExtraTrailDays(response.credit);
                        setShowCouponApplied(true);

                        return;
                      }
                    }
                    const validEmail = await getEmailExists(email);
                    if (validEmail.userFound) {
                      toast("User already exists");
                    } else {
                      if (registerThrough == "social" || !isRegister) {
                        onClickNext();
                      } else {
                        if (wasBackPressed) {
                          onClickNext();
                        } else {
                          setShowOtp(true);
                        }
                      }
                    }
                  }
                }}
                type="primary"
              >
                NEXT
              </div>
            </div>
          </div>
        </Transition.Child>
      </Transition>
    </>
  );
}

function FitAThonRegistration() {
  const location = useLocation();
  const [step, setStep] = useState(0);
  const [name, setName] = useState(location.state?.fullname);
  const [email, setEmail] = useState(location.state?.email);
  const [mobile, setMobile] = useState(location.state?.phone);
  const [password, setPassword] = useState();
  const [height, setHeight] = useState();
  const [weight, setWeight] = useState();
  const [gender, setGender] = useState();
  const [companyName, setCompanyName] = useState();
  const [dob, setDob] = useState();
  const [heightUnit, setHeightUnit] = useState("cm");
  const [weightUnit, setWeightUnit] = useState("KG");
  const [workoutGoal, setWorkoutGoal] = useState([]);
  const [workoutDuration, setWorkoutDuration] = useState([0]);
  const [injuries, setInjuries] = useState([]);
  const [answers, setAnswers] = useState({
    workingOutFrom: "",
    lastWorkedOut: "",
    refer: "",
  });
  const [otherInjuries, setOtherInjuries] = useState("");
  const [coupon, setCoupon] = useState("");
  const registerThrough = location.state?.registerThrough || "email";

  const navigate = useNavigate();
  const auth = useAuthContext();

  const utm_url = sessionStorage.getItem("utm_url") || null;

  async function register() {
    let user = {
      fullname: name,
      email: email ? email : "",
      height: height,
      weight: weight,
      workoutWeekDuration: workoutDuration[0],
      workoutGoal: workoutGoal,
      companyName: companyName,
      dob: dob
        .toLocaleString("en-us", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .replace(/(\d+)\/(\d+)\/(\d+)/, "$2/$1/$3"),
      gender: gender,
      hasInjury: injuries.includes("none") ? 0 : 1,
      injuries: injuries.includes("none")
        ? []
        : otherInjuries != ""
        ? [...injuries, otherInjuries]
        : injuries,
      refer: answers.refer,
      lastWorkedOut: answers.lastWorkedOut,
      workingOutFrom: answers.workingOutFrom,
      verifiedThrough: registerThrough,
      mobile: mobile ? "+91" + mobile : "",
      coupon: coupon,
      utm_url: utm_url,
    };
    console.log(user);
    const response = await FitAThonRegister(user);
    if (response.success) {
      toast("Registration Successful", { type: "success" });
      navigate("/registration_Complete");
    } else {
      toast(response.msg, { type: "error" });
    }
  }

  const createProgram = async () => {
    setShowCurationDialog(true);

    // let detials = {
    //   companyName: JSON.stringify(companyName),
    // };

    // await FitAThonRegister();
    setTimeout(async () => {
      await auth.updateUser();
      setShowCurationDialog(false);
      navigate("/programpage");
    }, 3000);
  };

  const [showCuratingDialog, setShowCurationDialog] = useState(false);
  const [wasBackPressed, setWasBackPressed] = useState(false);

  useEffect(() => {
    if (location.state && location.state?.phone != mobile) {
      setMobile(location.state.phone);
    }
    if (location.state && location.state?.email != email) {
      setEmail(location.state.email);
    }
  }, [location.state]);

  return (
    <div
      className={`font-open-sans w-full h-full px-6  py-20 md:px-16 lg:px-24 2xl:px-32 `}
      id="register"
    >
      <CuratingPlaylist show={showCuratingDialog} closeDialog={() => {}} />
      <div className="bg-white bg-opacity-5 rounded-lg overflow-clip">
        <div
          className="p-6 md:p-14 bg-no-repeat overflow-clip"
          style={{ backgroundImage: `url(${healthyLife})` }}
        >
          <p className="font-poppins text-white font-bold text-3xl md:text-4xl leading-snug">
            <span className="text-primary-neonGreen">FIT-A-THON</span>{" "}
            Registration
          </p>
          <p
            className={`text-white text-opacity-70 mt-2 mb-7 text-lg font-medium `}
          >
            Tell us more about you
          </p>
        </div>
        <div className="px-6 md:px-14">
          {step == 0 && (
            <RegistrationStep1
              wasBackPressed={wasBackPressed}
              isRegister={true}
              setStep={setStep}
              name={name}
              setName={setName}
              email={email}
              setEmail={setEmail}
              mobile={mobile}
              setMobile={setMobile}
              companyName={companyName}
              setCompanyName={setCompanyName}
              password={password}
              setPassword={setPassword}
              height={height}
              setHeight={setHeight}
              weight={weight}
              setWeight={setWeight}
              dob={dob}
              setDob={setDob}
              heightUnit={heightUnit}
              setHeightUnit={setHeightUnit}
              weightUnit={weightUnit}
              setWeightUnit={setWeightUnit}
              gender={gender}
              setGender={setGender}
              coupon={coupon}
              setCoupon={setCoupon}
              onClickNext={() => {
                setWasBackPressed(false);
                register();
              }}
              registerThrough={registerThrough}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default FitAThonRegistration;
